import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ElectricChargerOffIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M19.434 5.64791L22.0455 3.03646L20.7727 1.76367L15.2887 7.24767C14.8658 7.31408 14.538 7.52469 14.3051 7.8574V3.9814H3.7379V18.7984L1.69751 20.8388L2.9703 22.1116L5.02532 20.0566H5.03647L6.60727 18.4858H6.59611L12.7343 12.3476V12.3588L14.3051 10.788V10.7768L15.8147 9.26721V9.27837L17.025 8.06806C17.0236 8.06572 17.0222 8.06338 17.0209 8.06105L18.343 6.73892C18.3445 6.74116 18.346 6.74339 18.3474 6.74563L19.4391 5.65401C19.4374 5.65198 19.4357 5.64994 19.434 5.64791ZM12.7343 9.80203V5.5522H5.3087V17.2276L7.55796 14.9784L8.6543 12.7126H5.9819L9.4907 8.6734H10.6127L9.3887 11.203H11.3333L12.7343 9.80203ZM18.7931 8.84555L20.2218 7.41688C20.2483 7.60289 20.2619 7.79711 20.2619 8.0002V16.9762C20.2619 18.1186 19.3643 19.1998 18.0383 19.1998C16.7123 19.1998 15.8147 18.1186 15.8147 16.9762V11.824L17.2835 10.3552V16.9762C17.2835 17.3842 17.6303 17.731 18.0383 17.731C18.4463 17.731 18.7931 17.3842 18.7931 16.9762V8.84555ZM14.3051 20.0566H7.58205L9.15285 18.4858H12.7343V14.9044L14.3051 13.3336V20.0566Z"
      />
    </SvgIcon>
  );
});
